import dayjs from 'dayjs';
import React from 'react';

import { prettifyPhone } from '../../../../../utils/common/phones';
import { TableActions } from '../components/TableActions';
import { FeedbacksProps } from '../service/feedback.interface';

export const getColumns = () => [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: '66px',
        render: text => text,
    },
    {
        title: 'Сообщение',
        dataIndex: 'text',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: text => text,
    },
    {
        title: 'Имя',
        dataIndex: 'name',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: text => text || 'none',
    },
    {
        title: 'Создан',
        dataIndex: 'created_at',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: time => dayjs.unix(time).format('DD.MM.YY HH:mm'),
    },
    {
        title: 'Почта',
        dataIndex: 'email',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: text => text,
    },
    {
        title: 'Телефон',
        dataIndex: 'phone',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: (text: number | null) =>
            text ? prettifyPhone(text.toString()) : '',
    },
    {
        title: 'Статус',
        dataIndex: 'status',
        key: 'id',
        width: '89px',
        ellipsis: true,
        render: text => text || 0,
    },
    {
        title: 'Действие',
        dataIndex: '',
        key: 'id',
        width: '110px',
        render: (feedback: FeedbacksProps) => <TableActions {...feedback} />,
    },
];
